import { Job, RecruiterLiteFields } from '../types';

export const recruiterLiteWorkplaceOptions = [
  { label: 'On-site', value: 'On-site' },
  { label: 'Remote', value: 'Remote' },
  { label: 'Hybrid', value: 'Hybrid' },
] as const;

export const recruiterLiteEmploymentTypeOptions = [
  { label: 'Full-time', value: 'FULL_TIME' },
  { label: 'Part-time', value: 'PART_TIME' },
  { label: 'Contract', value: 'CONTRACT' },
  { label: 'Temporary', value: 'TEMPORARY' },
  { label: 'Other', value: 'OTHER' },
  { label: 'Volunteer', value: 'VOLUNTEER' },
  { label: 'Internship', value: 'INTERNSHIP' },
] as const;

export const recruiterLiteSeniorityOptions = [
  { label: 'Internship', value: 'INTERNSHIP' },
  { label: 'Entry level', value: 'ENTRY_LEVEL' },
  { label: 'Associate', value: 'ASSOCIATE' },
  { label: 'Mid-Senior level', value: 'MID_SENIOR_LEVEL' },
  { label: 'Director', value: 'DIRECTOR' },
  { label: 'Executive', value: 'EXECUTIVE' },
  { label: 'Not Applicable', value: 'NOT_APPLICABLE' },
] as const;

export const recruiterLiteApplyMethodOptions = [
  { label: 'LinkedIn application (recommended)', value: 'internal' },
  { label: 'External site', value: 'external' },
] as const;

export { functionChoices as recruiterLiteJobFunctionChoices } from '../constants';

const mapLocationTypeToWorkplace = (locationType?: string): RecruiterLiteFields['workplaceType'] => {
  switch (locationType) {
    case 'OnSite':
      return 'On-site';
    case 'Remote':
      return 'Remote';
    case 'Hybrid':
      return 'Hybrid';
    default:
      return undefined;
  }
};

const mapJobTypeToEmploymentType = (jobType?: string): RecruiterLiteFields['employmentType'] => {
  switch (jobType) {
    case 'FullTime':
    case 'Permanent':
      return 'FULL_TIME';
    case 'PartTime':
      return 'PART_TIME';
    case 'Contract':
      return 'CONTRACT';
    case 'Temporary':
      return 'TEMPORARY';
    default:
      return undefined;
  }
};

export const buildRecruiterLiteFieldsFromJob = (job: Partial<Job>): RecruiterLiteFields => {
  const saved = job.recruiterLiteFields || {};

  return {
    workplaceType: saved.workplaceType ?? mapLocationTypeToWorkplace(job.locationType),
    employeeLocation: saved.employeeLocation ?? job.location ?? '',
    employmentType: saved.employmentType ?? mapJobTypeToEmploymentType(job.jobType),
    seniorityLevel: saved.seniorityLevel,
    jobFunctions: saved.jobFunctions ?? [],
    skills: saved.skills ?? [],
    applyMethod: saved.applyMethod ?? 'internal',
    applyEmail: saved.applyEmail ?? job.recruiter?.email ?? '',
    requireResume: saved.requireResume ?? true,
    externalApplyUrl: saved.externalApplyUrl ?? '',
  };
};

export const emptyRecruiterLiteFields = (): RecruiterLiteFields => ({
  jobFunctions: [],
  skills: [],
  applyMethod: 'internal',
  applyEmail: '',
  requireResume: true,
  externalApplyUrl: '',
});

export type RecruiterLiteAutofillPayload = RecruiterLiteFields & {
  jobId?: string;
  clientName: string;
  jobTitle: string;
  jobDescription: string;
};

export const buildRecruiterLiteAutofillPayload = (job: Partial<Job>): RecruiterLiteAutofillPayload => ({
  ...buildRecruiterLiteFieldsFromJob(job),
  jobId: job._id,
  clientName: job.clientName || '',
  jobTitle: job.title || '',
  jobDescription: job.description || '',
});
